/* eslint-disable @typescript-eslint/no-explicit-any */
import {LogSource} from "./GemzAuditLog";

export interface GemzBalanceSchema {
    id: number;
    game_id?: number;
    offchain_game_id: number;
    user_id: number;
    wallet_address: string;
    transaction_hash: string;
    price: number;
    created_at: any; // timestamp type?
    source: LogSource;
}

export interface GemzBalance {
    onChainGameId?: number;
    offChainGameId: number;
    userId: number;
    walletAddress: string;
    transactionHash: string;
    price: number;
    source: LogSource;
}

export const getGemzBalanceFromSchema = (schema: GemzBalanceSchema): GemzBalance => ({
    onChainGameId: schema.game_id,
    offChainGameId: schema.offchain_game_id,
    userId: schema.user_id,
    walletAddress: schema.wallet_address,
    transactionHash: schema.transaction_hash,
    price: schema.price,
    source: schema.source,
})

export type GemzBalanceUpdateSchema = Omit<GemzBalanceSchema, 'id'| 'created_at'>
